<template>
  <div>
    <v-client-table :data="data.demandeImpressions"
      class='mgt-10px is-paddingless'
      :columns="columns"
      :options="options">
      <template #selected="{ row }">
        <b-checkbox
          :value="row.selected"
          @input="$emit('actionSelected', { id: row.id, selected: row.selected })"
          class="has-text-centered">
        </b-checkbox>
      </template>
      <template #dateDemande = "{ row }">
        <section class="columns is-multiline">
          <div class="column is-12">
            <router-link
              :to="{ name: 'c.logistique.demande_impression',
                params: { id: row.id }}"
              :class="{'text-access-no-permission':
              !checkPermissions(constantes.DEMANDE_IMPRESSION.lecture)}"
              class="lien">
              {{ getDate(row.dateDemande) }}
            </router-link>
            <b-icon
              v-if="getCouleurInformation(row.couleur)"
              :icon="getCouleurInformation(row.couleur).icon"
              :custom-class="getCouleurInformation(row.couleur).type"
              size="is-small"
              :class="{ 'demandeImpressionwhiteColorBorder' :
              getCouleurInformation(row.couleur).key === constantes.COULEUR_BLANC}"
            ></b-icon>
          </div>
          <div class="column is-12 pdt-0">
            <tag-list
              v-if="getTags(row.tagIds).length > 0"
              :listes="getTags(row.tagIds)"/>
          </div>
        </section>
      </template>
      <template #typeOtLibelle = "{ row }">
        {{ row.typeOtLibelle }}
      </template>
      <template #etat = "{ row }">
        <div :class="getClassTexte(row.etat)">
          {{ getLibelleEtat(row.etat) }}
        </div>
      </template>
      <template #clientNomCommercial = "{ row }">
        <router-link-blank
          :to="{ name: 'c.bodac.clients/contacts-client', params: { id: row.clientId } }"
          :class="{'text-access-no-permission':
            !checkPermissions(constantes.TIERS.lecture)}"
          :message="row.clientNomCommercial"
          class="lien">
        </router-link-blank>
      </template>
      <template #contactDemandeur = "{ row }">
        <router-link-blank
          v-if="row.contactDemandeurId"
          :to="{
            name: 'c.bodac.clients/contacts-contacts',
            params: {
              id: row.contactDemandeurId,
              isFromBailleur: false,
            }
          }"
          :class="{'text-access-no-permission':
            !checkPermissions(constantes.TIERS.lecture)}"
          :message="row.contactDemandeur"
          class="lien">
        </router-link-blank>
      </template>
      <template #dispositifCode = "{ row }" >
        <router-link-blank
          v-if="row.dispositifId"
          :to="{
            name: 'c.gabed.emplacement-detailDispositif',
            params: {
              idDispositif: row.dispositifId,
            }
          }"
          :message="row.dispositifCode"
          class="lien">
        </router-link-blank>
      </template>
      <template #dispositifEtat = "{ row }" >
        {{ getEtatDispositif(row.dispositifEtat) }}
      </template>
      <template #dispositifAdresse = "{ row }" >
        {{ getAdresse(row.dispositifAdresse) }}
      </template>
      <template #typeMateriel = "{ row }" >
        {{ getMaterielTypeLibelles(row.materielTypeLibelles) }}
      </template>
      <template #creatorUserName = "{ row }" >
        {{ row.creatorUserName }}
      </template>
      <template #quantite = "{ row }" >
        <div class="is-pulled-right">
          {{ row.quantite }}
        </div>
      </template>
      <template #soldeStock = "{ row }" >
        <div class="is-pulled-right">
          {{ row.soldeStock }}
        </div>
      </template>
      <template #campagneLibelle = "{ row }">
        <div class="has-text-left">
          <router-link-blank
            v-if="row.campagneId"
            :to="{ name: 'c.bodac.campagne', params: { id: row.campagneId } }"
            :class="{'text-access-no-permission':
              !checkPermissions(constantes.CAMPAGNE.lecture)}"
            :message="row.campagneLibelle"
            class="lien"/>
        </div>
      </template>
      <template #graphisteEnCharge = "{ row }">
        <div class="has-text-left">
          <router-link-blank
            v-if="row.graphisteEnChargeId"
            :to="{
              name: 'c.parametrage.collaborateurs',
              params: { id: row.graphisteEnChargeId },
            }"
            class="lien"
            :message="row.graphisteEnCharge"/>
        </div>
      </template>
      <template #edit = "{ row }">
        <div class="has-text-centered">
          <btn-action-icon
            :permission="constantes.DEMANDE_IMPRESSION.maj"
            @is-click="$router.push({ name: 'm.logistique.demande_impression-edit',
              params: { id: row.id } })"
            icon-type="is-success"
            icon="pencil-box-outline">
          </btn-action-icon>
        </div>
      </template>
      <template #supprimer = "{ row }">
        <div class="has-text-centered">
          <btn-action-icon
            :permission="constantes.DEMANDE_IMPRESSION.supprimer"
            :tooltip-label-disabled="$t('listeDemandeImpression.actions.deleteOTDisabled')"
            @is-click="askSupprimerDemande(row)"
            icon-type="is-danger"
            icon="delete-forever">
          </btn-action-icon>
        </div>
      </template>
      <template #createOt = "{ row }">
        <div class="has-text-centered">
          <btn-action-icon
            :permission="constantes.ORDRE_TRAVAIL_IMPRESSION.maj"
            @is-click="askcreateOt(row)"
            icon-type="is-primary"
            :disabled="actionDisabledIfOt(row)"
            :tooltip-label="$t('listeDemandeImpression.actions.creerOT')"
            :tooltip-label-disabled="$t('listeDemandeImpression.actions.creerOTDisabled')"
            icon="playlist-plus">
          </btn-action-icon>
        </div>
      </template>
    </v-client-table>
    <b-modal
      v-model="isSupprimerDemande"
      has-modal-card
      class="modal">
      <pop-up-prevention
        :messHeader="$t('listeDemandeImpression.popUpSuppression')"
        :cancel="$t('general.non')"
        :validate="$t('general.oui')"
        :messagesPopup="messagesErreurPopUp"
        :isErrorPopup.sync="errorPopUp"
        :champsVide="champsVide"
        :messagesChampsVide="messagesChampsVide"
        @no="annulerSuppression()"
        @yes="supprimerDemande()">
      </pop-up-prevention>
    </b-modal>
    <b-modal
      v-model="isCreateOt"
      has-modal-card
      class="modal">
      <pop-up-prevention
        :messHeader="$t('listeDemandeImpression.popUpCreationOt')"
        :cancel="$t('general.non')"
        :validate="$t('general.oui')"
        :messagesPopup="messagesErreurPopUp"
        :isErrorPopup.sync="errorPopUp"
        :champsVide="champsVide"
        :messagesChampsVide="messagesChampsVide"
        @no="annulerCreationOt()"
        @yes="createOtDemande()">
      </pop-up-prevention>
    </b-modal>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import {
  NO_PER_PAGE_VALUE, RESULTS_PER_POP_UP, SORT_ICON, TEXTS,
} from '@/configuration/clientTableConf';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import { DEMANDE_IMPRESSION, ORDRE_TRAVAIL_IMPRESSION } from '@/configuration/logistique/permissionsLogistiqueConf';
import {
  COULEUR_IMPRESSION,
  ETAT_DEMANDE_IMPRESSION,
  COULEUR_BLANC,
  COULEUR_ETAT_DEMANDE_IMPRESSION,
} from '@/configuration/logistique/demandeImpression/demandeImpressionConf';
import formatDate from '@/services/general/formatDate';
import { TIERS, CAMPAGNE } from '@/configuration/permissionsBodacConf';
import adressFullStringGetter from '@/services/general/adressFullStringGetter';
import { ETAT_DISPOSITIF_PUBLICITAIRE } from '@/configuration/gabed/dispositif/dispositifPublicitaire';
import BtnActionIcon from '@/components/general/btnActionIcon';
import { deleteDemandeImpression, createOTs } from '@/api/logistique/demandeImpression';
import validationOTTech from '@/services/logistique/ordreTravail/tech/validation/validation';
import validationDemandeImpression from '@/services/logistique/demandeImpression/validationDemandeImpression';
import validationGeneral from '@/services/validation/validation';
import translate from '@/services/logistique/ordreTravail/tech/validation/translate';
import messageErreur from '@/services/general/messageErreur';
import PopUpPrevention from '@/components/general/popUpPrevention';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import tagList from '@/components/general/tagList';

const Permissions = createNamespacedHelpers('permissions');
const Parametres = createNamespacedHelpers('parametres');

export default {
  name: 'childRowOtImpression',
  props: {
    data: {
      type: Object,
      required: true,
      default: null,
    },
  },
  data() {
    return {
      constantes: {
        DEMANDE_IMPRESSION,
        TIERS,
        ORDRE_TRAVAIL_IMPRESSION,
        COULEUR_BLANC,
        CAMPAGNE,
      },
      coloneSortExclusions: ['edit', 'supprimer', 'createOt', 'soldeStock', 'quantite'],
      isSupprimerDemande: false,
      idToRemove: null,
      isCreateOt: false,
      idToCreateOt: null,
      messagesErreurPopUp: [],
      errorPopUp: false,
      champsVide: [],
      messagesChampsVide: [],
    };
  },
  components: {
    routerLinkBlank,
    BtnActionIcon,
    PopUpPrevention,
    tagList,
  },
  computed: {
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    columns() {
      return [
        'selected',
        'dateDemande',
        'etat',
        'clientNomCommercial',
        'contactDemandeur',
        'dispositifCode',
        'dispositifEtat',
        'dispositifAdresse',
        'typeMateriel',
        'campagneLibelle',
        'creatorUserName',
        'quantite',
        'soldeStock',
        'graphisteEnCharge',
        'createOt',
        'edit',
        'supprimer'];
    },
    options() {
      const texts = cloneDeep(TEXTS);
      texts.count = '';
      return {
        sortIcon: SORT_ICON,
        headings: {
          dateDemande: this.$t('listeDemandeImpression.tabs.tabChildRow.date'),
          etat: this.$t('listeDemandeImpression.tabs.tabChildRow.etat'),
          clientNomCommercial: this.$t('listeDemandeImpression.tabs.tabChildRow.client'),
          contactDemandeur: this.$t('listeDemandeImpression.tabs.tabChildRow.demandeur'),
          dispositifCode: this.$t('listeDemandeImpression.tabs.tabChildRow.dispositif'),
          dispositifEtat: this.$t('listeDemandeImpression.tabs.tabChildRow.dispositifEtat'),
          dispositifAdresse: this.$t('listeDemandeImpression.tabs.tabChildRow.adresse'),
          campagneLibelle: this.$t('listeDemandeImpression.tabs.tabChildRow.campagne'),
          graphisteEnCharge: this.$t('listeDemandeImpression.tabs.tabChildRow.graphisteEnCharge'),
          creatorUserName: this.$t('listeDemandeImpression.tabs.tabChildRow.createur'),
          quantite: this.$t('listeDemandeImpression.tabs.tabChildRow.quantite'),
          soldeStock: this.$t('listeDemandeImpression.tabs.tabChildRow.soldeStock'),
          typeMateriel: this.$t('listeDemandeImpression.tabs.tabChildRow.typeMateriel'),
          selected: '',
          edit: '',
          supprimer: '',
          createOt: '',
        },
        columnsClasses: {
          selected: 'colonneSelected',
          dateDemande: 'width-120px',
          edit: 'colonneSelected',
          supprimer: 'colonneSelected',
          createOt: 'colonneSelected',
          etat: 'width-170px',
        },
        cellClasses: {
          etat: COULEUR_ETAT_DEMANDE_IMPRESSION.map(el => ({
            class: el.backgroundColor,
            condition: (row) => row.etat === el.key,
          })),
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: RESULTS_PER_POP_UP,
        texts: texts,
        sortable: this.columns.filter(c => !this.coloneSortExclusions.includes(c)),
      };
    },
  },
  methods: {
    getDate(date) {
      return formatDate(date);
    },
    getLibelleEtat(etatDemande) {
      const etatFind = ETAT_DEMANDE_IMPRESSION.find((etat) => {
        return etat.key === etatDemande;
      });
      return etatFind ? this.$i18n.t(etatFind.libelle) : '';
    },
    getCouleurInformation(couleur) {
      return COULEUR_IMPRESSION.find(
        (couleurImpression) => couleurImpression.key === couleur,
      );
    },
    getClassTexte(etatDemande) {
      return COULEUR_ETAT_DEMANDE_IMPRESSION
        .find(etat => etat.key === etatDemande)?.textClass ?? '';
    },
    getAdresse(adresse) {
      return adresse ? adressFullStringGetter(adresse) : '';
    },
    getEtatDispositif(codeEtat) {
      const etatFind = ETAT_DISPOSITIF_PUBLICITAIRE.find((etat) => {
        return etat.value === codeEtat;
      });
      return etatFind ? this.$i18n.t(etatFind.libelle) : null;
    },
    getMaterielTypeLibelles(materielTypes) {
      return materielTypes.map(el => el).join(', ');
    },
    getTags(tagIds) {
      return this.parametre(PARAMETRES_KEYS.tag).filter((tag) => {
        return tagIds.includes(tag.id);
      });
    },
    askSupprimerDemande(row) {
      this.isSupprimerDemande = true;
      this.idToRemove = row.id;
    },
    askcreateOt(row) {
      this.errorPopUp = false;
      this.messagesErreurPopUp = [];
      this.champsVide = [];
      this.messagesChampsVide = [];
      this.isCreateOt = true;
      this.idToCreateOt = row.id;
    },
    actionDisabledIfOt(row) {
      return row.otIds?.length !== 0;
    },
    annulerSuppression() {
      this.isSupprimerDemande = false;
      this.idToRemove = null;
    },
    annulerCreationOt() {
      this.isCreateOt = false;
      this.idToCreateOt = null;
    },
    async createOtDemande() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const OTids = (await createOTs([this.idToCreateOt])).data.result;
        if (OTids.length > 0) {
          this.$router.push({
            name: 'c.logistique.ordre_travail-tech',
            params: { id: OTids[0] },
          });
        }
      } catch (e) {
        if (e.response.data.error) {
          validationOTTech(e.response, this.messagesErreurPopUp);
          validationDemandeImpression(e.response, this.messagesErreurPopUp);
          validationGeneral(this.$i18n, e.response, this.champsVide,
            this.messagesErreurPopUp, this.messagesChampsVide, translate);
          this.errorPopUp = true;
        } else {
          messageErreur(this.$i18n);
        }
        throw e;
      } finally {
        loadingComponent.close();
      }
    },
    async supprimerDemande() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        await deleteDemandeImpression(this.idToRemove);
        this.$emit('recherche');
      } catch (error) {
        if (error.response.data.error) {
          validationDemandeImpression(error.response, this.messagesErreurPopUp);
          validationGeneral(this.$i18n, error.response, this.champsVide,
            this.messagesErreurPopUp, this.messagesChampsVide, translate);
          this.errorPopUp = true;
        } else {
          messageErreur(this.$i18n);
        }
        throw error;
      } finally {
        loadingComponent.close();
      }
      this.idToRemove = null;
      this.isSupprimerDemande = false;
    },
  },
};
</script>

<style scoped>

</style>
